import React from "react";

const TabSwitcher = ({ tabs }) => {
  return (
    <div>
      <div className="flex justify-between border-b border-gray-200 md:px-6 px-0">
        {tabs.map((item) => (
          <button
            key={item.id}
            onClick={item.onClick}
            className={`md:px-6 px-1 md:py-4 py-3 w-1/2 font-medium transition-all md:text-md md:text-sm text-xs relative ${
              item.border
                ? "text-gray-900"
                : "text-gray-400 hover:text-gray-900"
            }`}
          >
            {item.title}

            {item.border && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#2BACE2]" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabSwitcher;
